import React, { useEffect, useRef, useState } from 'react';
import { useParams, Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const VerifyEmailPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('Verifying your email...');
  const didFetch = useRef(false);

  useEffect(() => {
    if (didFetch.current) return;
    didFetch.current = true;
    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link.');
      return;
    }
    fetch(`${API_URL}/verify_email/${token}`)
      .then(async (res) => {
        const data = await res.json();
        if (res.ok && data.success) {
          setStatus('success');
          setMessage(data.message || 'Your email has been verified! You can now log in.');
        } else {
          setStatus('error');
          setMessage(
            data.message || data.error || 'Verification failed. The link may be invalid or expired.'
          );
        }
      })
      .catch(() => {
        setStatus('error');
        setMessage('Network error. Please try again later.');
      });
  }, [token]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', background: '#e3eafc' }}>
      <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px #039be51a', padding: '32px 32px 24px 32px', minWidth: 320, maxWidth: 360, textAlign: 'center' }}>
        <h2 style={{ color: status === 'success' ? '#43a047' : status === 'error' ? '#d32f2f' : '#039be5', fontWeight: 700, marginBottom: 18 }}>
          {status === 'loading' && 'Verifying...'}
          {status === 'success' && 'Email Verified!'}
          {status === 'error' && 'Verification Failed'}
        </h2>
        <div style={{ margin: '18px 0', color: status === 'error' ? '#d32f2f' : '#222', fontSize: '1.08rem', fontWeight: 500 }}>
          {status === 'loading' && (
            <span style={{ display: 'inline-block', marginBottom: 12 }}>
              <svg width="32" height="32" viewBox="0 0 50 50">
                <circle cx="25" cy="25" r="20" fill="none" stroke="#039be5" strokeWidth="5" strokeDasharray="31.4 31.4" strokeLinecap="round">
                  <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite" />
                </circle>
              </svg>
            </span>
          )}
          {message}
        </div>
        {status === 'success' && (
          <Link to="/login" style={{ display: 'inline-block', background: '#039be5', color: '#fff', fontWeight: 700, padding: '12px 32px', borderRadius: 8, textDecoration: 'none', fontSize: '1.08rem', marginTop: 18 }}>
            Go to Login
          </Link>
        )}
        {status === 'error' && (
          <div style={{ marginTop: 18 }}>
            <Link to="/register" style={{ color: '#039be5', fontWeight: 600, textDecoration: 'none', fontSize: '1.05rem' }}>
              Register Again
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage; 